export const EXTRA_SMALL = "480px"
export const SMALL = "720px"
export const LARGE = "1260px"



// WEBPACK FOOTER //
// ./src/components/common/constant/BreakPoints.js